!(function ($) {
    if ($("#waittimes").length) {
        var widget = $("#waittimes");
        widget.addClass("loading").find(".time").text("Loading wait times");
        var data_url = "/ajaxtsa/waittimes";
        $.ajax({
            url: data_url,
            dateType: "json",
            cache: !0,
            success: function (data) {
                var results = JSON.parse(data);
                var tsaname = results.name,
                    tsatime = results.rightnow_description,
                    tsawait = results.rightnow;
					dashoffset = 2000 - (5.333 * tsawait);//80 is about 90deg
                widget.removeClass("loading").addClass("loaded"),
                    widget.find(".wait").html(tsawait),
                    widget.find(".title").html(tsaname),
                    widget.find(".time").html(tsatime);

					if ($("#shape").length) {
						$("#shape")[0].setAttribute("stroke-dashoffset", dashoffset);
					}
            },
            error: function (data) {
                widget
                    .removeClass("loading")
                    .addClass("not-loaded")
                    .find(".checkpoint")
                    .html(
                        "<a href='https://www.tsawaittimes.com/security-wait-times/SLC/Salt-Lake-City-International' rel='nofollow'>Click here for wait times.</a>"
                    );
            },
            complete: function (data) {
                widget.is(":not(.loaded)") &&
                    widget
                        .removeClass("loading")
                        .find(".checkpoint")
                        .html(
                            "<a href='https://www.tsawaittimes.com/security-wait-times/SLC/Salt-Lake-City-International' rel='nofollow'>Click here for wait times.</a>"
                        );
            },
        });
    }
})(jQuery);
